import { app } from '../../../../app';
import { Controller } from './approve-access-request.controller';

app.component('approveAccessRequest', {
    controller: Controller,
    bindings: {
        companyId: '<',
        accessRequest: '<',
        accounts: '<',
    },
    templateUrl: require('./approve-access-request.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/approve/approve-access-request.component.js